// @ts-check

/** @type {import('./types/reports.types').ReportsContent} */
const maintenanceLog = () => {
  return [
    {
      label: 'Summary',
      icon: 'dashboard',
      pdf: { title: 'Pdf Title', colsWidth: [100, 100, 100, 100, 100] },
      view: {
        type: 'table',
        content: [
          {
            field: 'no',
            header: 'No.',
            // width: 100,
            // textAlign: 'center',
          },
          {
            field: 'assetName',
            header: 'Asset',
          },
          {
            field: 'total',
            header: 'Total',
            template: {
              component: 'MaintenanceColumn',
              data: {
                component: 'ModalTable',
                data: { onReady: openBreakdown },
              },
            },
          },
          {
            field: 'upcoming',
            header: 'Upcoming',
            template: {
              component: 'MaintenanceColumn',
              data: {
                component: 'ModalTable',
                data: { onReady: openBreakdown },
              },
            },
          },
          {
            field: 'delayed',
            header: 'Delayed',
            template: {
              component: 'MaintenanceColumn',
              data: {
                component: 'ModalTable',
                data: { onReady: openBreakdown },
              },
            },
          },
          {
            field: 'completed',
            header: 'Completed',
            template: {
              component: 'MaintenanceColumn',
              data: {
                component: 'ModalTable',
                data: { onReady: openBreakdown },
              },
            },
          },
          {
            header: 'Actions',
            template: {
              component: 'ActionButtons',
              data: [
                {
                  icon: 'icon-eye',
                  iconPack: 'feather',
                  text: 'Manage',
                  click: {
                    external: openLink,
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      label: 'Breakdown',
      icon: 'event',
      view: { type: 'table', content: breakdownTable() },
      pdf: {
        title: 'Maintenance Log - Breakdown',
        colsWidth: [80, 60, 80, 60, 120],
      },
    },
  ];
};

const breakdownTable = () => {
  return [
    { field: 'assetName', header: 'Asset' },
    {
      field: 'mainType',
      header: 'Type',
    },
    {
      field: 'type',
      header: 'Title',
    },
    {
      field: 'cost',
      header: 'Cost (RM)',
    },
    {
      field: 'detail',
      header: 'Details',
    },
    {
      field: 'status',
      header: 'Status',
    },
    {
      header: 'Actions',
      template: {
        component: 'ActionButtons',
        data: [
          {
            icon: 'icon-eye',
            iconPack: 'feather',
            text: 'Manage',
            click: {
              external: openLink,
            },
          },
        ],
      },
    },
  ];
};

const openBreakdown = async (self) => {
  let args = self.data.rowData;
  let modal = JSON.parse(JSON.stringify(self.modalTableApi));
  let field = args.column.field;
  return new Promise((resolve) => {
    const arr = [];
    Array.prototype.push.apply(arr, args[field].d.data);
    Array.prototype.push.apply(arr, args[field].s.data);
    Array.prototype.push.apply(arr, args[field].t.data);

    const dt = {
      assetName: args.assetName,
      assetId: args.assetId,
      data: arr,
    };
    modal.table.content = breakdownTable();
    modal.reportData = dt.data;
    // self.onReadyData.reportData(dt);
    let f = `${field.charAt(0).toUpperCase() + field.slice(1)}`;
    modal.title = `${f} Breakdown - ${args.assetName}`;
    modal.pdf.title = modal.title;
    modal.pdf.colsWidth = [80, 60, 80, 60, 120];
    self.onReadyData = modal;
    if (modal.reportData.length > 0) {
      resolve(true);
    } else {
      resolve(false);
    }
  });
};
const openLink = (args) => {
  let link = { Document: 1, Tire: 4, Service: 5 };

  window.open(
    `https://fleets.igeotechgps.com/maintenance/vehicle-view/${args.fmsId}/${
      link[args.mainType] ? link[args.mainType] : ''
    }`,
    '_blank',
  );
};
export { maintenanceLog };
